/**
 * Category switching for the "Explorer" mega menu (snippets/mega-explorer.liquid).
 * Opening and closing the dropdown stays with the theme's header-menu.js; this
 * element only swaps the visible category pane and the promo card copy.
 * Mouse: hover with a short intent delay. Keyboard/touch: click or focus.
 */
class MegaExplorer extends HTMLElement {
  connectedCallback() {
    this.cats = [...this.querySelectorAll('.mega-explorer__cat')];
    this.panes = [...this.querySelectorAll('.mega-explorer__pane[data-key]')];
    this.promo = this.querySelector('.mega-explorer__promo');
    if (!this.cats.length) return;

    this.onOver = (event) => {
      if (event.pointerType !== 'mouse') return;
      const cat = event.target.closest('.mega-explorer__cat');
      if (!cat || cat.classList.contains('is-active')) return;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.activate(cat.dataset.key), 80);
    };
    this.onLeave = () => clearTimeout(this.timer);
    this.onClick = (event) => {
      const cat = event.target.closest('.mega-explorer__cat');
      if (cat) this.activate(cat.dataset.key);
    };
    this.onFocus = (event) => {
      const cat = event.target.closest('.mega-explorer__cat');
      if (cat) this.activate(cat.dataset.key);
    };

    this.addEventListener('pointerover', this.onOver);
    this.addEventListener('pointerleave', this.onLeave);
    this.addEventListener('click', this.onClick);
    this.addEventListener('focusin', this.onFocus);
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
    this.removeEventListener('pointerover', this.onOver);
    this.removeEventListener('pointerleave', this.onLeave);
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('focusin', this.onFocus);
  }

  /** @param {string} key */
  activate(key) {
    for (const cat of this.cats) {
      const active = cat.dataset.key === key;
      cat.classList.toggle('is-active', active);
      cat.setAttribute('aria-selected', String(active));
    }

    let pane;
    for (const p of this.panes) {
      const active = p.dataset.key === key;
      p.classList.toggle('is-active', active);
      if (active) pane = p;
    }

    if (!pane || !this.promo) return;
    const title = this.promo.querySelector('[data-promo-title]');
    const text = this.promo.querySelector('[data-promo-text]');
    if (title) title.textContent = pane.dataset.promoTitle || this.promo.dataset.defaultTitle || '';
    if (text) text.textContent = pane.dataset.promoText || this.promo.dataset.defaultText || '';
    if (!this.promo.dataset.fixedImage && pane.dataset.promoImage) {
      this.promo.style.backgroundImage = `url('${pane.dataset.promoImage}')`;
    }
  }
}

if (!customElements.get('mega-explorer')) {
  customElements.define('mega-explorer', MegaExplorer);
}
